import styled from '@emotion/styled';
import * as DropdownMenu from '@radix-ui/react-dropdown-menu';

export default styled(DropdownMenu.SubTrigger)(({ theme }) => ({
    backgroundColor: 'inherit',
    border: 'none',
    padding: '0px',
    margin: '0px',
    display: 'flex',
    cursor: 'pointer',
    '&:focus-visible': {
        outline: `${theme.colors.primary50} auto 1px`,
    },
    '&:focus, &:hover': {
        outline: `${theme.colors.primary50} auto 1px`,
    },
    width: '100%',
}));
